module.exports = __webpack_public_path__ + "static/media/door2.c221b55d.png";